export default [
  {
    path: '',
    name: 'payment method list',
    component: () => import('@/views/app/payment-method/list/page-list.vue'),
    meta: { title: 'Daftar Metode Pembayaran' },
  },
  {
    path: 'baru',
    name: 'payment method create',
    component: () => import('@/views/app/payment-method/create/page-create.vue'),
    meta: { title: 'Tambah Ubah Metode Pembayaran' },
  },
  {
    path: 'edit/:id',
    name: 'payment method edit',
    component: () => import('@/views/app/payment-method/edit/page-edit.vue'),
    meta: { title: 'Ubah Metode Pembayaran' },
  },
]
